import React, { useState, useContext } from "react";
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import { authContext } from '../provider/Auth'
import { makeStyles } from '@material-ui/core/styles';
import LoadingButton from '../components/LoadingButton';


const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3, 2, 1, 2),
    margin: 'auto',
    marginTop: '150px',
    [theme.breakpoints.up('sm')]: {
      maxWidth: `320px`,
    }
  },
  textField: {
    width: '100%',
    marginBottom: '16px'
  },
  button: {
    width: '100%'
  }
}));

const Login = (props) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setLoading] = useState(false);
  const {state, login} = useContext(authContext);
  const {isAuthenticating, error} = state;
  const classes = useStyles();

  async function handleSubmit (e) {
    e.preventDefault ();
      
    try {
      setLoading (true);
      const credentials = await login(email, password);
      setLoading (false);
      if (!credentials.challengeName) {
        props.history.push("/");
      }
    } catch (e) {
      //alert(e.message);
    }
  }

  if (state.challenge) {
    return <CompleteChallenge email={email} {...props}/>
  }


  return <Paper className={classes.root}>
      <form onSubmit={handleSubmit}>
        <TextField value={email} onChange={e => setEmail(e.target.value)} className={classes.textField} label='Username' /><br/>
        {error&&<TextField value={password} error helperText={state.error.message} onChange={e => setPassword(e.target.value)} className={classes.textField} type='password' label='Password' />}
        {!error&&<TextField value={password} onChange={e => setPassword(e.target.value)} className={classes.textField} type='password' label='Password' />}
        <LoadingButton isLoading={isAuthenticating} className={classes.button} type='submit'>Login</LoadingButton>
      </form>
    </Paper> 
}

const CompleteChallenge = (props) => {
  const {state: {challenge: {challengeName}}} = useContext(authContext);
  switch (challengeName) {
    case 'NEW_PASSWORD_REQUIRED':
      return <NewPasswordRequiredChallenge {...props}/>
  }
}
const NewPasswordRequiredChallenge = (props) => {
  const { email } = props;
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const {state, newPassword} = useContext(authContext);
  const {isAuthenticating} = state;

  const classes = useStyles();

  const helperText = "Bitte ändern sie ihr Passwort."

  async function handleSubmit (e) {
    e.preventDefault ();
    try {
      await newPassword(password);
      props.history.push("/");
    } catch (e) {
    }
  }

  let error;
  if (state.error) {
    error = state.error;
  }
  if (password !== confirm) {
    if (!state.error) {
      error = {
        message: 'Die Passwörter stimmen nicht überein.'
      }
    } else {
      error = {
        message: `${state.error.message}.\nDie Passwörter stimmen nicht überein.`
      }
    }
  }
  
  return <Paper className={classes.root}>
      <form onSubmit={handleSubmit}>
        <TextField disabled helperText={helperText} value={email} className={classes.textField} label='Username' /><br/>
        <TextField value={password} onChange={e => setPassword(e.target.value)} className={classes.textField} type='password' label='Passwort' /><br/>
        {error&&<TextField value={confirm} error helperText={error.message} onChange={e => setConfirm(e.target.value)} className={classes.textField} type='password' label='Bestätigen' />}
        {!error&&<TextField value={confirm} onChange={e => setConfirm(e.target.value)} className={classes.textField} type='password' label='Bestätigen' />}        
        <LoadingButton disabled={!password || (password !== confirm)} variant="outlined" color="primary" isLoading={isAuthenticating} className={classes.button} type='submit'>Passwort ändern</LoadingButton>
      </form>
    </Paper> 
}
export default Login;